module.exports = __webpack_public_path__ + "static/media/icon-btc.26af0a21.svg";